import { Trash2 } from 'lucide-react';

import RestaurantEmptyState from '../../shared/RestaurantEmptyState';

const WasteEmpty = () => {
  return (
    <RestaurantEmptyState
      icon={Trash2}
      title="No hay mermas registradas"
      description="Cuando se registren pérdidas por vencimiento, daño, preparación u otros motivos, aparecerán aquí para revisar su impacto en inventario y costos."
      hint="Use Registrar merma para crear el primer movimiento"
    />
  );
};

export default WasteEmpty;
